<template>
  <b-modal
    id="cloneModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="cloneModal"
    @hidden="closemodal"
  >
    <div class="d-flex align-items-center justify-content-between p-3">
      <div class="teams-modal-head">
        {{ header }}
      </div>

      <div @click="closemodal">
        <img
          :style="buttonLoader ? 'opacity:50%' : ''"
          src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
          alt=""
          :class="!buttonLoader ? 'pointer rotate-on-hover' : ''"
        />
      </div>
    </div>
    <hr class="my-0" />
    <div class="p-4">
      <div class="topDiv">
        <label class="teams-label-font">{{ subHeader }}</label>

        <b-form-input
          :class="{
            'teams-inputField-error':
              $v.cloningName.$error ||
              duplicatecloneName == true ||
              !$v.cloningName.alpha ||
              (!$v.cloningName.maxLength && cloningName != ''),
          }"
          class="mt-2 teams-inputField"
          type="text"
          v-model.trim="cloningName"
          @input="$emit('change-duplicate-name')"
          :placeholder="placeholder"
          autofocus
          v-on:keyup.enter="cloneData"
        ></b-form-input>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="$v.cloningName.$dirty && !$v.cloningName.required"
        >
          Required
        </div>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="!$v.cloningName.maxLength && $v.cloningName.required"
        >
          Should not exceed 128 characters
        </div>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="!$v.cloningName.alpha && $v.cloningName.required"
        >
          Please Enter a Valid Name
        </div>
        <div
          class="newInt-required-validation-font mt-1"
          v-if="cloningName != '' && duplicatecloneName == true"
        >
          {{ errorMessage }}
        </div>
      </div>
    </div>
    <hr />
    <div class="d-flex align-items-center justify-content-end pb-3 px-3">
      <div class="cancelpan-btn mr-3">
        <b-button
          class="addbtn h-32 w-87"
          @click="closemodal"
          :disabled="buttonLoader"
          >Cancel</b-button
        >
      </div>
      <div class="addpanellog position-relative">
        <b-button
          class="addbtn h-32 w-87"
          @click="cloneData()"
          :class="buttonLoader ? 'givefeed-loader-class' : 'pointer'"
        >
          <span v-if="!buttonLoader"> {{ buttonName }} </span>
        </b-button>

        <div v-if="buttonLoader" class="loader-pos">
          <Loader />
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import Loader from "../../components/fixedcomponents/Loader.vue";

import toast from "../../components/mixin/toast";

export default {
  name: "CloneModal",
  components: {
    Loader,
  },
  props: {
    cloningData: Object,
    header: String,
    subHeader: String,
    placeholder: String,
    errorMessage: String,
    duplicatecloneName: Boolean,
    cloneModal: Boolean,
    buttonLoader: Boolean,
    buttonName: String,
  },
  mixins: [toast],

  data() {
    return {
      cloningName: "",
    };
  },
  watch: {
    cloneModal() {
      this.cloningName = "";
      this.$v.cloningName.$reset();
      this.$emit("handle-resetClone");
    },
  },
  validations() {
    return {
      cloningName: {
        required,
        maxLength: maxLength(128),
        alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
      },
    };
  },
  methods: {
    closemodal() {
      this.cloningName = "";
      this.$v.cloningName.$reset();
      this.$emit("closeCloneModal");
    },
    async cloneData() {
      this.$v.cloningName.$touch();
      if (!this.$v.cloningName.$invalid) {
        this.$emit("handle-clone", this.cloningName);
      }
    },
  },
};
</script>
<style>
.loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: -2px;
}
.givefeed-loader-class {
  opacity: 0.5;
  height: 32px;
  width: 87px;
}
.defaultCursor {
  cursor: default;
}
</style>
